import get from 'lodash/get';

export default {
  props: {
    ignoreFields: {
      type: Array,
      default: () => ([]),
    },
    ignoreTabs: {
      type: Array,
      default: () => ([]),
    },
    ignoreTypes: {
      type: Array,
      default: () => ([]),
    },
    only: {
      type: Object,
      default: () => ({
        relations: []
      })
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    modalInstance: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    MergeSmart(object1, object2) {
      const objectMerged = new Object();
      Object.keys(object1).forEach(key => {
        if(key in object2){
          objectMerged[key] = object1[key] ? object1[key] : object2[key];
          delete object2[key];
        }else
        {
          objectMerged[key] = object1[key];
        }
      });

      Object.keys(object2).forEach(key => {
        objectMerged[key] = object2[key];
      });
      return objectMerged;
    }
  },
  computed: {
    updateInstanceAction() {
      return this.modalInstance ? 'UPDATE_MODAL_INSTANCE' : 'UPDATE_INSTANCE';
    },
    setInstanceAction() {
      return this.modalInstance ? 'SET_MODAL_INSTANCE' : 'SET_INSTANCE';
    },
    setInstancePathAction() {
      return this.modalInstance ? 'SET_MODAL_INSTANCE_PATH' : 'SET_INSTANCE_PATH';
    },
    instance: {
      get () {
        const instance = this.modalInstance ? 'modalInstance' : 'instance';
        return !!this.path ? get(this.$store.state[instance], this.path) : this.$store.state[instance]
      },
      set (value) {
        this.$store.commit(this.updateInstanceAction, value)
      },
    },
    formData: {
      get () {
        return this.$store.state.formData;
      },
      set (value) {
        this.$store.commit('SET_FORM_DATA', value);
      }
    },
    portal() {
      return this.$route.params.portal;
    },
    relations () {
      const portalRelations = this
        .$fields(this.$findEntity(this.portal))
        .filter(f => !f.primitive && !f.section && f.extra);
      let relations = this.$fields(this.entity)
        .filter(p => !p.primitive && !p.section)
        .filter(f => !this.ignoreTabs.find(iT => f.name === iT))
        .filter(f => f.name == 'history' ? this.instance && this.instance.uid : true);

      if(ENV.ENTITIES[this.instance && this.instance._Entity] != null && !this.entity.extra){
        var summarySection = ENV.ENTITIES[this.instance._Entity].summarySection
        if(summarySection != null){
          relations.push({name:summarySection.tab, type:summarySection.type})
        }
      }

      if (this.portal) {
        relations = relations.filter(r => r.extra
          ? portalRelations.find(pr => pr.name === r.name)
          : true
        );
      }

      return relations;
    },
    fields () {
      return this.$fields(this.entity, 'primitive', this.ignoreTypes, this.only.fields, this.ignoreFields)
      // return this.entity.fields.filter(p => p.primitive)
    }
  }
}
